var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgParkena(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 100,
    viewBox: "0 0 82 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.6806 30.5173L82 53.0522L74.9528 60.0932L55.2147 40.1422L55.2147 100L45.11 100L45.11 69.9534L35.2409 69.9534L35.2409 100L25.1363 100L25.1363 33.567C17.775 31.377 11.7453 27.1905 7.04718 21.0076C2.34906 14.8246 -2.73533e-06 7.82213 0 8.86329e-06L10.1046 1.23968e-05C10.1046 6.88735 12.5322 12.7564 17.3874 17.6073C22.2426 22.4582 28.1169 24.8836 35.0104 24.8836L47.9319 24.8836C52.0052 24.8836 55.9214 26.7615 59.6806 30.5173V30.5173ZM30.0734 9.8603C30.0734 7.0426 31.0524 4.69563 33.0105 2.81939C34.9686 0.943149 37.3578 0.00336043 40.178 2.29132e-05C42.9982 -0.00331461 45.3874 0.936476 47.3455 2.81939C49.3036 4.70231 50.2827 7.04928 50.2827 9.86031C50.2827 12.6713 49.3036 15.0584 47.3455 17.0214C45.3874 18.9844 42.9982 19.9626 40.178 19.9559C37.3578 19.9493 34.9686 18.9711 33.0105 17.0214C31.0524 15.0717 30.0734 12.6847 30.0734 9.8603Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgParkena);
export default __webpack_public_path__ + "static/media/parkena.82687e21f3bbb7be8c9561f880af5884.svg";
export { ForwardRef as ReactComponent };